// Média ponderada pelo número de resoluções de cada time — soma simples do
// avg_resolution_time de cada time não faria sentido (times com poucas
// conversas puxariam a média igual a times com muitas).
export const weightedAvgResolutionTime = entries => {
  const totalResolved = entries.reduce(
    (sum, entry) => sum + (entry.resolved_conversations_count || 0),
    0
  );
  if (!totalResolved) return 0;

  const weightedSum = entries.reduce(
    (sum, entry) =>
      sum +
      (entry.avg_resolution_time || 0) * entry.resolved_conversations_count,
    0
  );
  return weightedSum / totalResolved;
};

// Filtra a resposta de summary_reports/team pelos times selecionados no
// seletor global do header — nenhum time selecionado significa "sem
// filtro" (usa todos).
export const filterByTeam = (data, teamIds) =>
  teamIds.length ? data.filter(entry => teamIds.includes(entry.id)) : data;
